(() => {
  const init = () => {
    document.querySelectorAll('.pause-pdp').forEach(root => {
      if (root.dataset.pauseUxReady) return;
      root.dataset.pauseUxReady = 'true';
      const reviewsLink = root.querySelector('.pause-pdp__reviews-link');
      if (reviewsLink) {
        const baseLabel = reviewsLink.textContent.trim();
        const syncReviewRating = () => {
          const rating = Number(window.grp_app_metadata?.rating);
          if (!Number.isFinite(rating) || rating <= 0 || rating > 5) return;
          const formatted = new Intl.NumberFormat(document.documentElement.lang || 'fr', {maximumFractionDigits:1}).format(rating);
          const text = `${baseLabel} · ${formatted}/5 Google`;
          if (reviewsLink.textContent !== text) reviewsLink.textContent = text;
        };
        syncReviewRating();
        window.addEventListener('load', syncReviewRating, {once:true});
        const reviewsSection = document.getElementById(reviewsLink.hash.slice(1));
        if (reviewsSection) new MutationObserver(syncReviewRating).observe(reviewsSection, {childList:true, subtree:true, characterData:true});
      }
      const refreshSelection = () => {
        root.querySelectorAll('variant-selects fieldset').forEach(fieldset => {
          const checked = fieldset.querySelector('input:checked');
          const legend = fieldset.querySelector('legend');
          if (!checked || !legend) return;
          let value = legend.querySelector('.pause-selected-option');
          if (!value) {
            value = document.createElement('span');
            value.className = 'pause-selected-option';
            legend.append(value);
          }
          value.textContent = ` : ${checked.value}`;
        });
      };
      root.querySelectorAll('.pause-variants-more').forEach(button => {
        const track = document.getElementById(button.getAttribute('aria-controls'));
        const selected = track.querySelector('input:checked');
        if (selected && Array.from(track.querySelectorAll('input')).indexOf(selected) > 3) {
          track.classList.add('is-expanded'); button.setAttribute('aria-expanded', 'true'); button.textContent = button.dataset.less;
        }
        button.addEventListener('click', () => {
          const expanded = track.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.less : button.dataset.more;
        });
      });
      const pickup = root.querySelector('pickup-availability');
      const delivery = root.querySelector('.availability-message');
      if (pickup && delivery) delivery.after(pickup);
      const priceBox = root.querySelector('[id^="price-"]');
      const primary = root.querySelector('.product-form__submit');
      const updateMoney = () => {
        priceBox?.querySelectorAll('[data-pause-money]').forEach(node => {
          const currency = node.dataset.currency;
          const formatted = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency}).format(Number(node.dataset.pauseMoney) / 100);
          if (node.textContent !== formatted) node.textContent = formatted;
        });
        const price = priceBox?.querySelector('.price');
        const current = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
        const amountNode = current?.querySelector('[data-pause-money]');
        const widget = root.querySelector('scalapay-widget');
        if (widget && amountNode) {
          const amount = (Number(amountNode.dataset.pauseMoney) / 100).toFixed(2);
          if (widget.getAttribute('amount') !== amount) widget.setAttribute('amount', amount);
        }
        const label = primary?.querySelector('span');
        if (current && amountNode && label && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') {
          const text = `${amountNode.textContent.trim()} — ${root.dataset.addLabel}`;
          if (label.textContent !== text) label.textContent = text;
        }
      };
      let moneyFrame;
      const scheduleMoney = () => { cancelAnimationFrame(moneyFrame); moneyFrame = requestAnimationFrame(updateMoney); };
      const moneyObserver = new MutationObserver(scheduleMoney);
      if (priceBox) moneyObserver.observe(priceBox, {childList:true, subtree:true, characterData:true});
      if (primary) moneyObserver.observe(primary, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled']});
      updateMoney();
      refreshSelection();
      root.addEventListener('change', event => {
        if (event.target.closest('variant-selects')) requestAnimationFrame(refreshSelection);
      });
      const gallery = root.querySelector('media-gallery');
      if (gallery) {
        const observer = new IntersectionObserver(entries => {
          document.body.classList.toggle('pause-gallery-in-view', entries[0].isIntersecting);
        });
        observer.observe(gallery);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();


